export default "__VITE_ASSET__dee02ece__"